import {
  MONITORING_CONFIGS,
  MONITORING_TYPES,
  type MonitoringType,
} from "@/constants/monitoring";
import type { RateLimitDefaults } from "../types/rate-limit.types";

interface RateLimitFeature {
  title: string;
  scope: string;
  unit: string;
  /** RemixIcon class, shared with the rest of the app's monitoring modules. */
  icon: string;
  /** Accent classes built on the --color-monitor-* tokens. */
  accent: string;
  /** Server-side fallback, shown as the input placeholder. */
  fallback: number;
}

const featureFor = (
  type: MonitoringType,
  rest: Omit<RateLimitFeature, "title" | "icon">,
): RateLimitFeature => ({
  title: MONITORING_CONFIGS[type].label,
  icon: MONITORING_CONFIGS[type].icon,
  ...rest,
});

export const RATE_LIMIT_FEATURES: Record<
  keyof RateLimitDefaults,
  RateLimitFeature
> = {
  keyword_monitoring_calls_per_min: featureFor(MONITORING_TYPES.KEYWORD, {
    scope: "Per API key",
    unit: "calls / min",
    accent: "bg-monitor-keyword/10 text-monitor-keyword",
    fallback: 100,
  }),
  influencer_monitoring_requests_per_min: featureFor(
    MONITORING_TYPES.INFLUENCER,
    {
      scope: "Per user",
      unit: "req / min",
      accent: "bg-monitor-influencer/10 text-monitor-influencer",
      fallback: 5,
    },
  ),
  source_monitoring_calls_per_min: featureFor(MONITORING_TYPES.SOURCE, {
    scope: "Per user",
    unit: "calls / min",
    accent: "bg-monitor-source/10 text-monitor-source",
    fallback: 10,
  }),
};

export const RATE_LIMIT_FIELDS = Object.keys(
  RATE_LIMIT_FEATURES,
) as (keyof RateLimitDefaults)[];
